export default __webpack_public_path__ + "media/react.191cbcb7.png";